import { useEffect, useState } from "react";
import InputData from "./InputData";
import ButtonIconH from "./ButtonIconH";
import Dropdown from "./Dropdown";
import { post } from "../js/post";
import { focusElement, selectedOptic, userData } from "../js/utils";
import { useOptometrists } from "../hooks/useOptometrists";
import WacomSignaturePopup from "./WacomSignaturePopup";

export function ORTHOKConsent({
  patientData,
  createPopupQuestion,
  removePopupQuestion,
  onClose,
}) {
  const optometristList = [{ id: "", text: "" }, ...useOptometrists()];
  const [data, setData] = useState({
    agente: "",
    nombreResponsable: "",
    dniResponsable: "",
  });
  const [wacomPopup, setWacomPopup] = useState(false);

  // console.log("data: ", data);

  const generateConsent = async (signature) => {
    const response = await post(
      "/support-extra/gestionDocumental/GenerarDocumentoORTOK.php",
      {
        token: userData.token,
        idOptica: selectedOptic.id,
        idPaciente: patientData.id,
        firma: signature,
        ...data,
      },
    );
    // console.log(
      // "GENERANDO: ",
      // {
        // token: userData.token,
        // idOptica: selectedOptic.id,
        // idPaciente: patientData.id,
        // firma: signature,
        // ...data,
      // },
      // response,
    // );
    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      const a = document.createElement("a");
      a.href = response.fichero;
      a.download = `ORTHOK_${patientData.name}.pdf`;
      a.click();
      createPopupQuestion(
        "Consentimiento ORTHO-K generado satisfactoriamente.",
        () => {
          onClose();
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  };

  const checkOptometrist = () => {
    if (data.agente === "") {
      createPopupQuestion(
        "Seleccione un optometrista.",
        () => {
          removePopupQuestion();
          focusElement(200);
        },
        null,
        "Entendido",
      );
      return false;
    }
    return true;
  };

  useEffect(() => {
    setData((prev) => ({
      ...prev,
      nombreResponsable: patientData.name,
      dniResponsable: patientData.nif,
    }));
  }, [patientData]);

  useEffect(() => {
    focusElement(200);
  }, []);

  return (
    <div className="popup-container">
      {wacomPopup && (
        <WacomSignaturePopup
          onSave={async (signature) => {
            setWacomPopup(false);
            await generateConsent(signature);
          }}
          onClose={() => {
            setWacomPopup(false);
          }}
          createPopupQuestion={createPopupQuestion}
          removePopupQuestion={removePopupQuestion}
        />
      )}
      <div className="ap-container popup-screen">
        <div className="popup-screen-header">
          <span className="popup-screen-header-title">
            Consentimiento ORTO-K
          </span>
          <button
            className="popup-action-icon close-icon"
            onClick={() => {
              onClose(data);
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
        </div>
        <div
          className={`tab-content ap-content`}
          style={{ overflow: "unset", backgroundColor: "#f9f9f9" }}
        >
          <div className="container-panel">
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
              <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 20,
                  }}
                >
                  <div
                    className="opt-table-tooltip grid-5"
                    id="gdpr-consent-grid"
                  >
                    <div className="cell cell-label cell-start-content">
                      Optometrista
                    </div>
                    <div className="cell cell-label">
                      <Dropdown
                        tabIndex={200}
                        optionList={optometristList}
                        size={0}
                        op={data.agente}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            agente: e.text,
                          }));
                        }}
                      ></Dropdown>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      DNI responsable
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={201}
                        type="type-only-charnumbers"
                        size={0}
                        maxLength={12}
                        input={data.dniResponsable}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            dniResponsable: e,
                          }));
                        }}
                      ></InputData>
                    </div>
                    <div className="cell cell-label cell-start-content">
                      Paciente
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={-1}
                        type="type-only-charnumbers"
                        size={0}
                        input={patientData.name}
                        inactive={true}
                        onChange={() => {}}
                        onClick={() => {}}
                      ></InputData>
                    </div>
                    <div className="cell"></div>
                    <div className="cell cell-label cell-start-content">
                      Responsable
                    </div>
                    <div className="cell cell-label">
                      <InputData
                        tabIndex={202}
                        type="type-alpha"
                        size={0}
                        input={data.nombreResponsable}
                        onChange={(e) => {
                          setData((prev) => ({
                            ...prev,
                            nombreResponsable: e,
                          }));
                        }}
                      ></InputData>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="popup-buttons"
                style={{ justifyContent: "center", gap: 20 }}
              >
                <ButtonIconH
                  text="Firmar"
                  small={true}
                  onClick={() => {
                    if (checkOptometrist()) setWacomPopup(true);
                  }}
                ></ButtonIconH>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
